module.exports = __webpack_public_path__ + "img/base.8d6b855b.svg";